import { AuditReportsAudioStatusDto } from '@mi-front/api-v2';
import { createCustomIdColumn } from '@app/modules/audit/components/create-custom-id-column';
import { MrtTable } from '@mi-front/ui';
import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

interface GipReportMissingMaterialsViewProps {
  audiosStatusByStation: {
    [key: string]: AuditReportsAudioStatusDto[];
  };
}

interface MissingMaterialRow {
  stationName: string;
  customId: string;
}

export const GipReportMissingMaterialsView = ({
  audiosStatusByStation,
}: GipReportMissingMaterialsViewProps) => {
  const { $t } = useIntl();
  const missingMaterials = useMemo(() => {
    const materials: MissingMaterialRow[] = [];

    Object.entries(audiosStatusByStation).forEach(([stationSlug, audioStatuses]) => {
      // Filter for missing audios (audioId is null)
      const missingAudios = audioStatuses.filter((audio) => audio.audioId === null);

      missingAudios.forEach((audio) => {
        materials.push({
          stationName: stationSlug,
          customId: audio.customId,
        });
      });
    });

    return materials;
  }, [audiosStatusByStation]);

  const columns = useMemo<MRT_ColumnDef<MissingMaterialRow>[]>(
    () => [
      {
        accessorKey: 'stationName',
        header: $t({
          id: 'audit.gipReport.columnStation',
          defaultMessage: 'Emisora',
        }),
        size: 150,
      },
      createCustomIdColumn<MissingMaterialRow>($t, {
        accessor: (row) => row.customId,
        size: 300,
      }),
    ],
    [$t],
  );

  return <MrtTable columns={columns} data={missingMaterials} rowCount={missingMaterials.length} />;
};
